import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ReactDOM from 'react-dom';
import { connect } from 'react-redux';
import Modal from '../common/Modal/Modal';

class ModalPortal extends Component {
  constructor(props) {
    super(props);
    this.portalRoot = document.getElementById("portal");
  }

  render() {
    return ReactDOM.createPortal(
      <Modal
        desiredClassName={this.props.className}
        error={this.props.error}
        errorMessageList={this.props.failedUploads}
        isActive={this.props.isActive}
        linkTo={this.props.linkTo}
        useCloseButton={false}
        useSpinner={this.props.isLoading}
        onClose={this.props.onClose && this.props.onClose.bind(this)}
        simpleMessageList={this.props.message}
      />,
      this.portalRoot
    );
  }
}

ModalPortal.propTypes = {
  className: PropTypes.string.isRequired,
  error: PropTypes.bool.isRequired,
  failedUploads: PropTypes.array.isRequired,
  isActive: PropTypes.bool.isRequired,
  isLoading: PropTypes.bool.isRequired,
  message: PropTypes.array,
  onClose: PropTypes.func,
  linkTo: PropTypes.object,
  submission: PropTypes.object.isRequired,
};

ModalPortal.defaultProps = {
  message: [],
  onClose: () => {}
};

function mapStateToProps(state) {
  return {
    isActive: state.modal.showModal,
    error: state.modal.error,
    isLoading: state.submissionInfo.submission.isLoading,
    failedUploads: state.attachments.failed,
    hasFailedUploads: state.attachments.failed.length > 0,
    className: state.modal.className,
    linkTo: state.modal.link,
    message: state.modal.message,
    onClose: state.modal.onClose,
    submission: state.submission
  };
}

export default connect(
  mapStateToProps,
  {}
)(ModalPortal);

export { ModalPortal as PureModalPortal };

